import React from "react";
import { useAuth } from "../../AuthContext";
import { auth } from "../../firebase";
import { useActiveBar } from "../ActiveBarContext";
import GamingEditor from "../charity/Gaming.jsx";
import TodaysSpecialPoster from "../shared/TodaysSpecialPoster.jsx";

export default function Gaming() {
  const { user, userBars } = useAuth();
  const ownedBars = userBars.filter((bar) => bar.ownerId === user?.uid);
  const { activeBar } = useActiveBar();

  if (ownedBars.length === 0) {
    return (
      <p style={{ color: "#fff" }}>
        You haven't claimed a bar yet. Claim a bar first to see its gaming inventory here.
      </p>
    );
  }

  const charityManaged = ownedBars.filter((b) => b.charityId);
  const ownerManaged = ownedBars.filter((b) => !b.charityId);

  return (
    <div style={{ color: "#fff" }}>
      {/* Staff/owner photo post of the pull-tab boxes or winner board (24 hours). */}
      {activeBar && (
        <div style={{ maxWidth: "560px", marginBottom: "30px" }}>
          <TodaysSpecialPoster
            kind="pulltabs"
            disabled={!activeBar}
            getAuthBody={async () => ({ barId: activeBar.id })}
            getAuthHeaders={async () => {
              const token = await auth.currentUser?.getIdToken();
              return token ? { Authorization: `Bearer ${token}` } : {};
            }}
          />
          <p style={{ color: "#B8B0C8", fontSize: "15px", marginTop: "10px" }}>
            Your staff can post these too from <strong>portal.barfunfinder.com/staff-post</strong> with your staff code.
          </p>
        </div>
      )}

      {/* No charity account? The owner keeps the gaming info up to date. */}
      {ownerManaged.length > 0 && <GamingEditor mode="owner" />}

      {charityManaged.length > 0 && (
        <>
          <h2 style={{ marginBottom: "10px" }}>Managed by your charity</h2>
          <p style={{ marginBottom: "20px", color: "#B8B0C8" }}>
            These bars have a charity account that keeps gaming info up to date, so it's read-only here.
          </p>
        </>
      )}

      {charityManaged.map((bar) => (
        <div
          key={bar.id}
          style={{
            background: "#0D0B1A",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "16px",
          }}
        >
          <h3 style={{ marginBottom: "8px" }}>{bar.name || "Unnamed Bar"}</h3>

          {!bar.charityId ? (
            <p style={{ color: "#B8B0C8" }}>
              No charity linked to this bar yet, so no gaming is set up.
            </p>
          ) : !bar.gaming ? (
            <p style={{ color: "#B8B0C8" }}>
              A charity is linked, but hasn't set up gaming yet.
            </p>
          ) : (
            <>
              {bar.gaming.charityName && (
                <p style={{ margin: "0 0 6px" }}>
                  <strong>Operated by:</strong> {bar.gaming.charityName}
                </p>
              )}
              <p style={{ margin: "0 0 6px" }}>
                <strong>Software:</strong> {bar.gaming.software === "none" ? "None" : bar.gaming.software}
              </p>
              {bar.gaming.games && bar.gaming.games.length > 0 && (
                <p style={{ margin: "0 0 6px", color: "#B8B0C8" }}>
                  {bar.gaming.games.join(", ")}
                </p>
              )}
              <p style={{ margin: "0 0 6px" }}>
                <strong>Terminals:</strong> {bar.gaming.terminals || 0} &nbsp;
                <strong>Pull-tab Boxes:</strong> {bar.gaming.pulltabBoxes || 0}
              </p>
              <p style={{ margin: "0 0 6px" }}>
                <strong>Sports Tip Boards:</strong> {bar.gaming.tipBoards ? "Yes" : "No"}
              </p>
              <p style={{ margin: "0 0 6px" }}>
                <strong>Hours:</strong> {bar.gaming.openTime || "—"} to {bar.gaming.closeTime || "—"}, {bar.gaming.days || "—"}
              </p>
              {bar.gaming.licenseNumber && (
                <p style={{ margin: "0 0 6px" }}>
                  <strong>License #:</strong> {bar.gaming.licenseNumber}
                </p>
              )}
              {bar.gaming.pulltabPhotoURL && (
                <img
                  src={bar.gaming.pulltabPhotoURL}
                  alt="Pull-tab booth"
                  style={{ width: "100%", maxWidth: "280px", borderRadius: "8px", marginTop: "10px", display: "block" }}
                />
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
}